<!-- 创建时间2022/07/01 17:12:12 -->
<!-- 创建人：zhu xiao hu -->
<!-- 组件描述：鉴定-选择鉴定人-抽屉 -->
<template>
  <div>
    <yxt-drawer
      ref="addStuDrawer"
      size="960px"
      :visible.sync="visible"
      :header-border='false'
      destroy-on-close
      :before-close="beforeClose"
      @closed="handleClosed"
    >
      <yxtbiz-range-selector
        ref="selector"
        :enableGroupCorp="isGroup"
        :functionCode="isGroup ? 'group_task_center' : 'o2o_train_center'"
        :dataPermissionCode="isGroup ? 'task_manage_platform' : 'FaceToFaceTeaching_chooseLecturer_extent'"
        v-model="newUsers"
        :tabs="tabs"
        :limit="limit"
        :group-limit="0"
        :visibleOrgIds="[]"
        model="array"
        showTab
        @change="handelSelectChange"
      >
      </yxtbiz-range-selector>
      <div slot="footer">
        <yxt-button plain @click="visible = false">{{ $t('pc_biz_utility_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" :loading="loading" @click="sureHandle">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>

export default {
  props: {
    projectId: [Number, String],
    groupId: [Number, String],
    functionCode: [Number, String],
    startTime: [String],
    tabs: {
      type: Array,
      default: () => {
        return ['persons', { type: 'userGroup', isPerson: true }, 'advance'];
      }
    },
    isGroup: Boolean,
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    this.isChange = false;
    return {
      visible: false,
      loading: false,
      getLeaderList: [],
      msgVisible: false,
      msgTitle: '',
      msgContent: '',
      newUsers: [], // 多选
      selectProjectUsers: [],
      selectAllMap: new Map(), // 存储所有选中数据
      selectAllList: [], // 存储所有选中数据的数组
      limit: 30
    };
  },
  methods: {
    init() {
      this.visible = true;
      Object.assign(this.newUsers, this.data);
    },
    async sureHandle() {
      try {
        const isValidate = await this.$refs.selector.validate();
        if (isValidate) {
          const selectedStudents = await this.$refs.selector.getSelectDataArray();
          if (selectedStudents.length === 0) {
            return this.$message.error(this.$t('pc_biz_common__tip_place_select_user' /* 请选择人员 */));
          } else {
            this.$emit('chooseAssigner', selectedStudents);
            this.visible = false;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    beforeClose(done) {
      done(this.isChange);
    },
    handleClosed() {
      this.users = [];
      this.isChange = false;
      this.newUsers = [];
      this.selectAllList = [];
      this.selectAllMap = new Map();
      this.selectProjectUsers = [];
      this.loading = false;
    },
    // 自定义数据change
    selectProjectUser(val, isAdd) {
      let list = val;
      this.selectProjectUsers = val;

      // 将自定义选中的列表，加到其他tab选中列表中
      list && list.length > 0 && list.forEach(item => {
        if (isAdd) {
          this.selectAllMap.set(item.id, item);
        } else {
          this.selectAllMap.delete(item.id);
        }
      });
      this.newUsers = Array.from(this.selectAllMap.values());
      this.selectAllList = Array.from(this.selectAllMap.values());
    },
    // 选择用户组件，选中人员发生改变
    handelSelectChange(user, group) {
      // 因为操作项目内学员的时候，user为空
      // 清除全部时，清空所有数据
      if (!(this.selectProjectUsers.length > 0 && user.length === 0)) {
        this.selectAllMap = new Map();
      }
      let list = [...user, ...group];
      list.length > 0 && list.forEach(item => {
        this.selectAllMap.set(item && item.id, item);
      });
      this.selectAllList = Array.from(this.selectAllMap.values());
      this.selectProjectUsers = [];
      this.isChange = this.selectAllList.length > 0;
    }
  }
};
</script>
